import React, { useState, useContext, useEffect, useImperativeHandle, useRef } from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { Link, useLocation, useNavigate } from "react-router-dom";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiInput from "components/SuiInput";
import SuiButton from "components/SuiButton";
import Chip from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";
import Avatar from "@mui/material/Avatar";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemButton from "@mui/material/ListItemButton";

import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import NumbersIcon from "@mui/icons-material/Numbers";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";

import toast from "react-hot-toast";

import CategoryContext from "context/category-context";

import api from "services/api";
import moment from "moment";

import colors from "assets/theme/base/colors";

import { useForm, Controller } from "react-hook-form";

const InspirePromptTagModal = React.forwardRef(
  (
    {
      visible,
      handleClose,
      handleOk,
      promptRef,
      jobconf,
      setJobconf,
      handleRefresh = () => {},
      handleAfterOk = () => {},
      refreshDelay = 0,
    },
    ref
  ) => {
    const [loading, setLoading] = useState(false);
    const [inspiredTags, setInspiredTags] = useState([]);
    const [selectedTags, setSelectedTags] = useState([]);

    useEffect(() => {
      if (promptRef?.current?.value || (jobconf?.prompt_array && jobconf.prompt_array.length > 0)) {
        const text = promptRef?.current?.value;
        handleInspirePromptTags(text);
      }
    }, []);

    const handleSave = () => {
      let prompt_array = jobconf?.prompt_array || [];
      prompt_array = [...prompt_array, ...selectedTags];

      setJobconf((prev) => ({ ...prev, prompt_array }));
      handleClose();
    };

    const handleToggleInspiredPromptTags = (tag) => {
      const findIndex = selectedTags.findIndex((x) => x == tag);
      if (findIndex > -1) {
        //do delete
        const newTags = selectedTags.filter((x) => x != tag);
        setSelectedTags(newTags || []);
      } else {
        //do add
        setSelectedTags([...selectedTags, tag]);
      }
    };

    const handleInspirePromptTags = async (text) => {
      let input_text = text || "";
      if (jobconf?.prompt_array && jobconf.prompt_array.length > 0) {
        if (input_text) {
          input_text = input_text + ". " + jobconf.prompt_array.join(",");
        } else {
          input_text = jobconf.prompt_array.join(",");
        }
      }

      if (!input_text) {
        return toast.error("Please provide some hint!");
      }
      try {
        const payload = {
          data: {
            input_text: input_text,
          },
        };
        setLoading(true);
        const res = await api.ailab.promptTagRec(payload);
        let prompt_tag_rec = res?.data?.result?.results?.answer || "";

        prompt_tag_rec = prompt_tag_rec.replace(/design feature \d+:\s*\n*/g, "");

        let arr = prompt_tag_rec.split(",");
        arr = arr.map((x) => x.trim()).filter((x) => x != "");
        console.log(arr);
        setInspiredTags(arr);
        let initialSelectedTags = [];

        for (let i = 0; i < arr.length; i++) {
          for (let j = 0; j < jobconf.prompt_array.length; j++) {
            if (arr[i]?.value && arr[i]?.value == jobconf.prompt_array[j]) {
              initialSelectedTags.push(arr[i]);
            }
          }
        }
        if (initialSelectedTags.length > 0) {
          setSelectedTags(initialSelectedTags);
        }

        setLoading(false);
      } catch (err) {
        console.log(err);
        setLoading(false);
        toast.error("Failed to get inspired Prompt Tags!");
      }
    };

    return (
      <Dialog
        open={visible}
        onClose={(e, reason) => {
          if (reason != "backdropClick") {
            handleClose();
          }
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="md"
        fullWidth={true}
      >
        <Backdrop sx={{ color: "info", zIndex: (theme) => 99999 }} open={loading}>
          <CircularProgress color="info" sx={{ mr: 1 }} size={32} />
          <SuiTypography variant="h6" fontWeight="medium" color="info">
            Loading...
          </SuiTypography>
        </Backdrop>

        <DialogTitle id="alert-dialog-title">
          Fashion Tags Inspiration
          <IconButton
            aria-label="close"
            onClick={() => handleClose()}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <SuiTypography variant="body1" color="dark" sx={{ mb: 1 }}>
            Revamp the sentence with a touch of AI chic, and sprinkle in some futuristic fashion
            tags to elevate the style.
          </SuiTypography>
          <SuiBox display="flex" flexWrap="wrap" gap={0.5}>
            {inspiredTags.map((it) => {
              return (
                <SuiBox>
                  <Chip
                    label={it}
                    variant={selectedTags && selectedTags.includes(it) ? "contained" : "outlined"}
                    sx={{ mb: 0.5 }}
                    onClick={() => handleToggleInspiredPromptTags(it)}
                    color={selectedTags && selectedTags.includes(it) ? "primary" : "default"}
                  />
                </SuiBox>
              );
            })}
            {/* {selectedTags && selectedTags.length > 0 ? (
                  <Chip
                    icon={<RefreshIcon />}
                    label={"Refresh"}
                    variant={"contained"}
                    sx={{ mb: 0.5 }}
                    onClick={() => {
                      const text = promptRef?.current?.value + " " + selectedTags.join(",");
                      handleInspirePrompt(text);
                      setSelectedIndex(null);
                    }}
                    color={"secondary"}
                  />
                ) : null} */}
          </SuiBox>
        </DialogContent>
        <DialogActions>
          <SuiButton
            variant="gradient"
            size="medium"
            color="info"
            onClick={() => {
              const text = promptRef?.current?.value + " " + selectedTags.join(",");
              handleInspirePromptTags(text);
            }}
          >
            Refresh
          </SuiButton>
          <SuiButton size="medium" variant="gradient" color="dark" onClick={handleSave}>
            Apply
          </SuiButton>
        </DialogActions>
      </Dialog>
    );
  }
);

export default InspirePromptTagModal;
